import client from "../api/client";

/**
 * Send the signed-in user to the E1X Community platform, already signed in.
 *
 * Community authenticates on its own, so we ask Laravel for a one-time handoff
 * code (POST /community/handoff/issue — auth via the bearer token the axios
 * client attaches) and go to the URL it returns, which the Community app
 * exchanges for its own session. The code is single-use and short-lived, so it
 * is minted at click time rather than baked into a link.
 *
 * Resolves only if the redirect was started; throws if Community isn't
 * reachable/configured so the caller can tell the user.
 */
export async function goToCommunity() {
  const { data } = await client.post("/community/handoff/issue");

  if (!data?.url) {
    // Laravel returns url: null when COMMUNITY_FRONTEND_URL isn't configured.
    throw new Error("Community isn't available right now. Please try again later.");
  }

  window.location.assign(data.url);
}
